const moduleName = 'profile',
	selectors = {
		base: `.js-${moduleName}`,
		fileInput: `.js-${moduleName}-fileinput`,
		photo: `.js-${moduleName}-photo`,
		removePhoto: `.js-${moduleName}-remove-photo`,
		removePhotoBtn: `.js-${moduleName}-remove-photo-btn`,
		formChanged: '.js_form_changed'
	}

export class Profile {
	constructor(baseElement) {
		this.element = baseElement;
		this.fileInput = this.element.querySelector(selectors.fileInput);
		this.removePhoto = this.element.querySelector(selectors.removePhoto);
		this.removePhotoBtn = this.element.querySelector(selectors.removePhotoBtn);

		this.bindEvents();

	}

	onChangeHandler() {
		const context = this;

		if (this.files && this.files[0]) {
			const reader = new FileReader()
			reader.onload = function (e) {
				const target = $(context).attr('data-target');
				$(target).removeClass('c-profile-header__headshot__default');
				$(target).css({ 'background-image': 'url(' + e.target.result + ')' });
				$(selectors.formChanged).show();
			};

			reader.readAsDataURL(this.files[0]);
		}
	}

	onRemoveHandler() {
		this.fileInput.value = '';
		this.removePhoto.value = true;

		const target = this.fileInput.dataset?.target;
		$(target).css({ 'background-image': '' });
		$(target).addClass('c-profile-header__headshot__default');
		$(selectors.formChanged).show();
	}

	bindEvents() {
		this.fileInput?.addEventListener('change', this.onChangeHandler);
		this.removePhotoBtn?.addEventListener('click', this.onRemoveHandler.bind(this));
	}

}

function initProfile() {
	
	document.querySelectorAll(selectors.base).forEach((element) => {
		new Profile(element);
	});
}

initProfile();